(() => {
  const initializedAttribute = 'data-pot-product-initialized';

  const parseVariants = (root) => {
    const source = root.querySelector('[data-pot-variants]');
    if (!source) return [];

    try {
      return JSON.parse(source.textContent);
    } catch (error) {
      console.error('Points of Tango: unable to read product variants.', error);
      return [];
    }
  };

  const initProduct = (root) => {
    if (root.hasAttribute(initializedAttribute)) return;
    root.setAttribute(initializedAttribute, 'true');

    const mediaItems = [...root.querySelectorAll('[data-pot-media-id]')];
    const mediaButtons = [...root.querySelectorAll('[data-pot-media-target]')];
    const mediaCounter = root.querySelector('[data-pot-media-current]');
    const optionSelects = [...root.querySelectorAll('[data-pot-option-index]')];
    const variantInput = root.querySelector('[data-pot-variant-id]');
    const variants = parseVariants(root);

    const showMedia = (mediaId) => {
      const requestedId = String(mediaId || '');
      const activeItem = mediaItems.find((item) => item.dataset.potMediaId === requestedId) || mediaItems[0];
      if (!activeItem) return;

      mediaItems.forEach((item) => {
        item.hidden = item !== activeItem;
      });

      mediaButtons.forEach((button) => {
        if (button.dataset.potMediaTarget === activeItem.dataset.potMediaId) {
          button.setAttribute('aria-current', 'true');
        } else {
          button.removeAttribute('aria-current');
        }
      });

      if (mediaCounter) {
        mediaCounter.textContent = String(mediaItems.indexOf(activeItem) + 1);
      }
    };

    mediaButtons.forEach((button) => {
      button.addEventListener('click', () => showMedia(button.dataset.potMediaTarget));
    });

    const updateText = (selector, value) => {
      root.querySelectorAll(selector).forEach((element) => {
        element.textContent = value;
      });
    };

    const updateVariant = () => {
      if (!variants.length || !variantInput) return;

      const selectedOptions = optionSelects.map((select) => select.value);
      const variant = variants.find(
        (candidate) =>
          candidate.options.length === selectedOptions.length &&
          candidate.options.every((value, index) => value === selectedOptions[index])
      );

      const addButton = root.querySelector('.product-form__submit');
      const comparePrice = root.querySelector('[data-pot-compare-price]');
      const quantity = root.querySelector('.pot-product-quantity');

      if (!variant) {
        variantInput.disabled = true;
        if (addButton) addButton.disabled = true;
        updateText('[data-pot-add-label]', 'Unavailable');
        updateText('[data-pot-availability], [data-pot-detail-availability]', 'Unavailable');
        return;
      }

      variantInput.value = variant.id;
      variantInput.disabled = !variant.available;
      if (addButton) addButton.disabled = !variant.available;
      updateText('[data-pot-add-label]', variant.available ? 'Add to bag' : 'Sold out');
      updateText('[data-pot-availability], [data-pot-detail-availability]', variant.available ? 'Available' : 'Sold out');
      updateText('[data-pot-price]', variant.priceLabel);

      if (comparePrice) {
        comparePrice.hidden = !variant.compareLabel;
        comparePrice.textContent = variant.compareLabel || '';
      }

      if (variant.sku) {
        updateText('[data-pot-sku]', `Style ${variant.sku}`);
        updateText('[data-pot-detail-sku]', variant.sku);
      }

      if (quantity) {
        quantity.min = variant.quantityMin || 1;
        quantity.step = variant.quantityStep || 1;
        if (Number(quantity.value) < Number(quantity.min)) quantity.value = quantity.min;
      }

      if (variant.mediaId) showMedia(variant.mediaId);

      if (window.history?.replaceState) {
        const productUrl = root.dataset.productUrl || window.location.pathname;
        window.history.replaceState({}, '', `${productUrl}?variant=${variant.id}`);
      }
    };

    optionSelects.forEach((select) => select.addEventListener('change', updateVariant));
  };

  const initAllProducts = (container = document) => {
    container.querySelectorAll('[data-pot-product-root]').forEach(initProduct);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAllProducts());
  } else {
    initAllProducts();
  }

  document.addEventListener('shopify:section:load', (event) => initAllProducts(event.target));
})();
